import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface PageStateProps {
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  tone?: "muted" | "danger";
  className?: string;
}

export function PageState({
  title,
  description,
  children,
  tone = "muted",
  className,
}: PageStateProps) {
  return (
    <div
      className={cn(
        "flex h-64 flex-col items-center justify-center gap-3 rounded-md border px-6 text-center",
        tone === "danger" ? "text-destructive" : "text-muted-foreground",
        className,
      )}
    >
      {title ? <p className="text-lg font-medium text-foreground">{title}</p> : null}
      {description ? <p className="max-w-sm text-sm">{description}</p> : null}
      {children}
    </div>
  );
}

export interface QueryErrorStateProps {
  title: string;
  message: string;
  isForbidden?: boolean;
  forbiddenMessage?: string;
  className?: string;
}

export function QueryErrorState({
  title,
  message,
  isForbidden = false,
  forbiddenMessage = "Your account is not authorised to access the admin panel. Contact the team to request access.",
  className,
}: QueryErrorStateProps) {
  return (
    <PageState
      title={isForbidden ? "Access denied" : title}
      description={isForbidden ? forbiddenMessage : message}
      tone="danger"
      className={className}
    />
  );
}
